module.exports = __webpack_public_path__ + "static/media/deep_vertical_domain_knowledge_img.e5bb711a.png";